<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<mat-spinner class="spinner-center" *ngIf="isLoading"></mat-spinner>

<div *ngIf="isLoadingForUpdate">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<!-- start profile user -->
<div class="container text-center" *ngIf="userProfile && !isLoading">
  <div style="padding-bottom: 20px;">
    <div *ngIf="!isEdit">
      <h1>ข้อมูลส่วนตัว</h1><br />
      <img class="profilePic" [src]="userProfilePic"><br />
      <div class="row justify-content-center" *ngIf="userProfile.IS_PREMIUM">
        <h2 class="premium">Premium <img src="../../../assets/crown.png" width="30px" height="30px"></h2>
      </div>
      <!-- <br *ngIf="!isPremium" /> -->
      <div *ngIf="!userProfile.IS_PREMIUM">
        <div style="margin:20px;">
          <a routerLink="/upgrade-premium">
            <span>
              อัพเกรดสถานะเป็น
            </span>
            <span class="text-danger">
              Premium?
            </span>
          </a>
        </div>
      </div>

      <div class="frameProfileUser">
        <div class="row justify-content-center">
          <div class="col-6 text-right">
            <p>Username :</p>
          </div>
          <div class="col-6 text-left">
            <p>{{ userProfile.USERNAME }}</p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-6 text-right">
            <p>Email :</p>
          </div>
          <div class="col-6 text-left">
            <p>{{ userProfile.EMAIL }}</p>
          </div>
        </div>
        <div *ngIf="userProfile.TYPE_REGISTER === 0" class="row justify-content-center">
          <div class="col-6 text-right">
            <p>รหัสผ่าน :</p>
          </div>
          <div class="col-6 text-left">
            ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-6 text-right">
            <p>เพศ :</p>
          </div>
          <div class="col-6 text-left">
            <p>{{userProfile.GENDER}}</p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-6 text-right">
            <p>วัน/เดือน/ปีเกิด :</p>
          </div>
          <div class="col-6 text-left">
            <p *ngIf="date">{{ userProfile.DATE_OF_BIRTH | date:'full' }} ({{ age }} ปี)</p>
            <p *ngIf="!date">-</p>
          </div>
        </div>
        <div class="row justify-content-center" *ngIf="userProfile.IS_PREMIUM">
          <div class="col-6 text-right">
            <p>วันสิ้นสุดสถานะ Premium :</p>
          </div>
          <div class="col-6 text-left">
            <p *ngIf="date">{{ userProfile.PREMIUM_EXPIRE_DATE | date:'full' }}</p>
            <p *ngIf="!date">-</p>
          </div>
        </div>
        <div *ngIf="!userProfile.IS_PREMIUM"></div>

        <div class="row justify-content-center">
          <h2><img src="../../../assets/coin.png" width="30px" height="30px" style="margin-right: 10px;">
            {{ userProfile.COIN | number }} Coin</h2>
        </div>
        <a style="float: right; top: -20px; right: 30px; position: relative;">
          <span class="text-primary" (click)="deleteAccount(userProfile.USER_ID, userProfile.ROLE)">ลบบัญชีผู้ใช้</span>
        </a>
      </div>
    </div>

    <!-- edit user profile -->
    <div *ngIf="isEdit">
      <h1>แก้ไขข้อมูลส่วนตัว</h1><br />
      <form *ngIf="isEdit" [formGroup]="userProfileForm">
        <img class="profilePic" [src]="editUserProfile" (click)="selectAvatar()"
          style="margin-bottom:20px; cursor: pointer;"><br />
        <div class="frameProfileUser">
          <div class="form-group row justify-content-center">
            <label for="Username" class="col-4 text-right col-form-label">Username<lifedi-require></lifedi-require>
              :</label>
            <div class="col-5">
              <input type="text" class="form-control" id="Username" formControlName="username" autocomplete="off">
            </div>
          </div>
          <div class="form-group row justify-content-center">
            <div class="col-5 text-right">
              <p>Email :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{userProfile.EMAIL}}</p>
            </div>
          </div>
          <div *ngIf="userProfile.TYPE_REGISTER === 0" class="form-group row justify-content-center">
            <div class="col-4 text-right">
              <span>รหัสผ่าน :</span>
            </div>
            <div class="col-5 text-left">
              ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
            </div>
          </div>
          <div class="form-group row justify-content-center">
            <label for="gender" class="col-4 text-right col-form-label">เพศ<lifedi-require></lifedi-require> :</label>
            <div class="col-5">
              <select class="custom-select" id="gender" formControlName="gender">
                <option value="ชาย">ชาย</option>
                <option value="หญิง">หญิง</option>
                <option value="ไม่ระบุ">ไม่ระบุ</option>
              </select>
            </div>
          </div>
          <div class="form-group row justify-content-center">
            <label for="dateOfBirth" class="col-4 text-right col-form-label">วัน/เดือน/ปีเกิด<lifedi-require>
              </lifedi-require> :</label>
            <div class="col-5">
              <input type="text" class="form-control" formControlName="dateOfBirth" placement="top" bsDatepicker
                [(bsValue)]="userProfileForm.value.dateOfBirth"
                value="{{ userProfileForm.value.dateOfBirth | date:'DD/MM/YYYY' }}"
                [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-5">
              <!-- <lifedi-btn lable="บันทึก" customStyle="color:white; background-color: #3E8C1A;"
              (click)="clickUpdate(userProfileForm)">
            </lifedi-btn> -->
              <lifedi-btn lable="บันทึก" *ngIf="getEdit() && !userProfileForm.valid" disabled="true">
              </lifedi-btn>
              <lifedi-btn lable="บันทึก" *ngIf="getEdit() && userProfileForm.valid"
                customStyle="color:white; background-color: #3E8C1A;" (click)="clickUpdate(userProfileForm)">
              </lifedi-btn>
            </div>
          </div>
        </div>
      </form>
    </div>


    <lifedi-btn *ngIf="getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(userProfile)">
    </lifedi-btn>
    <lifedi-btn *ngIf="!getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit()">
    </lifedi-btn>
  </div>
</div>

<!-- end profile user -->


<!-- start profile teacher -->

<div class="container text-center" *ngIf="teacherProfile && !isLoading">
  <div style="padding-bottom: 20px;">
    <h1 style="font-weight: bold; font-size: xx-large;">ข้อมูลส่วนตัว</h1><br />
    <div *ngIf="isEdit">
      <div class="row justify-content-center">
        <label for="fileField">
          <img class="profilePic" [src]="selectedFile"><br />
        </label>
      </div>
      <div class="row justify-content-center">
        <input type="file" id="fileField" accept=".png, .jpg, .jpeg"
          (change)="onFileSelected($event, teacherProfileForm)">
      </div>
    </div>
    <div *ngIf="!isEdit">
      <img class="profilePic" [src]="selectedFile"><br />
    </div>
    <div *ngIf="!isEdit" class="row">
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <div class="row justify-content-center ">
            <div class="col-6 text-right">
              <p>Username :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ teacherProfile.USERNAME }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>Email :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ teacherProfile.EMAIL }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>รหัสผ่าน :</p>
            </div>
            <div class="col-6 text-left">
              ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>เพศ :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ teacherProfile.GENDER }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>วัน/เดือน/ปีเกิด :</p>
            </div>
            <div class="col-6 text-left">
              <p *ngIf="date">{{ teacherProfile.DATE_OF_BIRTH | date:'full' }} ({{ age }} ปี)</p>
              <p *ngIf="!date">-</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>เบอร์โทรศัพท์ :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ teacherProfile.PHONENUMBER | phoneNO }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <h2 class="text-center">ความเชี่ยวชาญ</h2>
          <div class="row">
            <mat-chip-list *ngFor="let exp of teacherProfile.EXPERTIES" aria-label="expertie">
              <mat-chip style="margin: 10px;">{{ exp.EXPERTIE_NAME }}</mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isEdit" class="row">
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <form *ngIf="isEdit" [formGroup]="teacherProfileForm">
            <div class="form-group row justify-content-center">
              <label for="Username" class="col-4 text-right col-form-label">Username<lifedi-require></lifedi-require>
                :</label>
              <div class="col-5">
                <input type="text" class="form-control" id="Username" formControlName="username" autocomplete="off">
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <div class="col-5 text-right">
                <p>Email :</p>
              </div>
              <div class="col-6 text-left">
                <p>{{ teacherProfile.EMAIL }}</p>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <div class="col-4 text-right">
                <span>รหัสผ่าน :</span>
              </div>
              <div class="col-5 text-left">
                ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="gender" class="col-4 text-right col-form-label">เพศ<lifedi-require></lifedi-require> :</label>
              <div class="col-5">
                <select class="custom-select" id="gender" formControlName="gender">
                  <option value="ชาย">ชาย</option>
                  <option value="หญิง">หญิง</option>
                  <option value="ไม่ระบุ">ไม่ระบุ</option>
                </select>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="dateOfBirth" class="col-4 text-right col-form-label">วัน/เดือน/ปีเกิด :</label>
              <div class="col-5">
                <input type="text" class="form-control" formControlName="dateOfBirth" placement="top" [ngModel]="date"
                  bsDatepicker [(bsValue)]="date" value="{{ date | date:'DD/MM/YYYY' }}"
                  [bsConfig]=" { containerClass: 'theme-red', showWeekNumbers: false }">
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="phoneNO" class="col-4 text-right col-form-label">เบอร์โทรศัพท์ :</label>
              <div class="col-5">
                <input type="text" class="form-control" formControlName="phoneNO" placement="top" MaxLength="10"
                  (keypress)="checkNumber($event)">
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <h2 class="text-center">ความเชี่ยวชาญ<lifedi-require></lifedi-require>
          </h2>
          <div class="row justify-content-center">
            <!-- <lifedi-chip #chips field="EXPERTIE_NAME" style="width: 80%; margin: 0 auto;"
              [selectedItem]="teacherProfile.EXPERTIES" [allItem]="experties"
              (outputSelected)="getSelectedItem($event, teacherProfileForm)">
            </lifedi-chip> -->
            <nz-select nzMode="multiple" nzPlaceHolder="โปรดเลือกความเชี่ยวชาญ" [(ngModel)]="teacherProfile.EXPERTIES"
              #exp class="text-left" [change]="getSelectedItem(exp, teacherProfileForm)" [compareWith]="compareFn">
              <nz-option *ngFor="let exp of experties" [nzLabel]="exp.EXPERTIE_NAME" [nzValue]="exp">
              </nz-option>
            </nz-select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="frame">
          <h2 class="text-center col-12">ประวัติและความสนใจ<lifedi-require *ngIf="isEdit"></lifedi-require>
          </h2>
          <div *ngIf="!isEdit" class="col-12">
            <div id="_content" [innerHtml]="teacherProfile.PERSONAL_DESCRIPTION | sanitizeHtml"></div>
          </div>
          <div *ngIf="isEdit" class="col-12">
            <form [formGroup]="teacherProfileForm">
              <angular-editor id="_content" formControlName="description" placeholder="ใส่ประวัติ และ ความสนใจของคุณ"
                [config]="editorConfig">
              </angular-editor>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="text-danger text-center" *ngIf="errorMsg">
      <p>{{ errorMsg }}</p>
    </div>

    <lifedi-btn lable="บันทึก" *ngIf="getEdit()"
      customStyle="color:white; background-color: #3E8C1A; margin-right: 10px; padding: 0 50px"
      (click)="clickUpdate(teacherProfileForm)">
    </lifedi-btn>
    <lifedi-btn *ngIf="getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(teacherProfile)">
    </lifedi-btn>
    <lifedi-btn *ngIf="!getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(teacherProfile)">
    </lifedi-btn>
  </div>
</div>

<!-- end profile teacher -->


<!-- start profile pshcologist -->

<div class="container text-center" *ngIf="psycologistProfile && !isLoading">
  <div style="padding-bottom: 20px;">
    <h1 style="font-weight: bold; font-size: xx-large;">ข้อมูลส่วนตัว</h1><br />
    <div *ngIf="isEdit">
      <div class="row justify-content-center">
        <label for="fileField">
          <img class="profilePic" [src]="selectedFile"><br />
        </label>
      </div>
      <div class="row justify-content-center">
        <input type="file" id="fileField" accept=".png, .jpg, .jpeg"
          (change)="onFileSelected($event, psycologistProfileForm)">
      </div>
    </div>
    <div *ngIf="!isEdit">
      <img class="profilePic" [src]="selectedFile"><br />
    </div>
    <div *ngIf="!isEdit" class="row">
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <div class="row justify-content-center ">
            <div class="col-6 text-right">
              <p>Username :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ psycologistProfile.USERNAME }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>Email :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ psycologistProfile.EMAIL }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>รหัสผ่าน :</p>
            </div>
            <div class="col-6 text-left">
              ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>เพศ :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ psycologistProfile.GENDER }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>วัน/เดือน/ปีเกิด :</p>
            </div>
            <div class="col-6 text-left">
              <p *ngIf="date">{{ psycologistProfile.DATE_OF_BIRTH | date:'full' }} ({{ age }} ปี)</p>
              <p *ngIf="!date">-</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>เบอร์โทรศัพท์ :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ psycologistProfile.PHONENUMBER | phoneNO }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <h2 class="text-center">ความเชี่ยวชาญ</h2>
          <div class="row">
            <mat-chip-list *ngFor="let exp of psycologistProfile.EXPERTIES" aria-label="expertie">
              <mat-chip style="margin: 10px;">{{ exp.EXPERTIE_NAME }}</mat-chip>
            </mat-chip-list>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isEdit" class="row">
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <form *ngIf="isEdit" [formGroup]="psycologistProfileForm">
            <div class="form-group row justify-content-center">
              <label for="Username" class="col-4 text-right col-form-label">Username<lifedi-require></lifedi-require>
                :</label>
              <div class="col-5">
                <input type="text" class="form-control" id="Username" formControlName="username" autocomplete="off">
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <div class="col-5 text-right">
                <p>Email :</p>
              </div>
              <div class="col-6 text-left">
                <p>{{ psycologistProfile.EMAIL }}</p>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <div class="col-4 text-right">
                <span>รหัสผ่าน :</span>
              </div>
              <div class="col-5 text-left">
                ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="gender" class="col-4 text-right col-form-label">เพศ<lifedi-require></lifedi-require> :</label>
              <div class="col-5">
                <select class="custom-select" id="gender" formControlName="gender">
                  <option value="ชาย">ชาย</option>
                  <option value="หญิง">หญิง</option>
                  <option value="ไม่ระบุ">ไม่ระบุ</option>
                </select>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="dateOfBirth" class="col-4 text-right col-form-label">วัน/เดือน/ปีเกิด :</label>
              <div class="col-5">
                <input type="text" class="form-control" formControlName="dateOfBirth" placement="top" [ngModel]="date"
                  bsDatepicker [(bsValue)]="date" value="{{ date | date:'DD/MM/YYYY' }}"
                  [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="phoneNO" class="col-4 text-right col-form-label">เบอร์โทรศัพท์ :</label>
              <div class="col-5">
                <input type="text" class="form-control" formControlName="phoneNO" placement="top" MaxLength="10"
                  (keypress)="checkNumber($event)">
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <h2 class="text-center">ความเชี่ยวชาญ<lifedi-require></lifedi-require>
          </h2>
          <div class="row justify-content-center">
            <!-- <lifedi-chip #chips field="EXPERTIE_NAME" style="width: 80%; margin: 0 auto;"
              [selectedItem]="psycologistProfile.EXPERTIES" [allItem]="experties"
              (outputSelected)="getSelectedItem($event, psycologistProfileForm)">
            </lifedi-chip> -->
            <nz-select nzMode="multiple" nzPlaceHolder="โปรดเลือกความเชี่ยวชาญ"
              [(ngModel)]="psycologistProfile.EXPERTIES" #exp class="text-left"
              [change]="getSelectedItem(exp, psycologistProfileForm)" [compareWith]="compareFn">
              <nz-option *ngFor="let exp of experties" [nzLabel]="exp.EXPERTIE_NAME" [nzValue]="exp">
              </nz-option>
            </nz-select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="frame">
          <h2 class="text-center col-12">ประวัติและความสนใจ<lifedi-require *ngIf="isEdit"></lifedi-require>
          </h2>
          <div *ngIf="!isEdit" class="col-12">
            <p id="_content" [innerHtml]="psycologistProfile.PERSONAL_DESCRIPTION | sanitizeHtml"></p>
          </div>
          <div *ngIf="isEdit" class="col-12">
            <form [formGroup]="psycologistProfileForm">
              <angular-editor id="_content" formControlName="description" placeholder="ใส่ประวัติ และ ความสนใจของคุณ"
                [config]="editorConfig">
              </angular-editor>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="text-danger text-center" *ngIf="errorMsg">
      <p>{{ errorMsg }}</p>
    </div>

    <lifedi-btn lable="บันทึก" *ngIf="getEdit()"
      customStyle="color:white; background-color: #3E8C1A; margin-right: 10px; padding: 0 50px"
      (click)="clickUpdate(psycologistProfileForm)">
    </lifedi-btn>
    <lifedi-btn *ngIf="getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(psycologistProfile)">
    </lifedi-btn>
    <lifedi-btn *ngIf="!getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(psycologistProfile)">
    </lifedi-btn>
  </div>
</div>

<!-- end profile pshcologist -->

<!-- start profile admin -->

<div class="container text-center" *ngIf="adminProfile && !isLoading">
  <div style="padding-bottom: 20px;">
    <h1 style="font-weight: bold; font-size: xx-large;">ข้อมูลส่วนตัว</h1><br />
    <div *ngIf="isEdit">
      <div class="row justify-content-center">
        <label for="fileField">
          <img class="profilePic" [src]="selectedFile"><br />
        </label>
      </div>
      <div class="row justify-content-center">
        <input type="file" id="fileField" accept=".png, .jpg, .jpeg" style="width: 88px;"
          (change)="onFileSelected($event, adminProfileForm)">
      </div>
    </div>
    <div *ngIf="!isEdit">
      <img class="profilePic" [src]="selectedFile"><br />
    </div>
    <div *ngIf="!isEdit" class="row justify-content-center">
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <div class="row justify-content-center ">
            <div class="col-6 text-right">
              <p>Username :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ adminProfile.USERNAME }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>Email :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ adminProfile.EMAIL }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>รหัสผ่าน :</p>
            </div>
            <div class="col-6 text-left">
              ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>เพศ :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ adminProfile.GENDER }}</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>วัน/เดือน/ปีเกิด :</p>
            </div>
            <div class="col-6 text-left">
              <p *ngIf="date">{{ adminProfile.DATE_OF_BIRTH | date:'full' }} ({{ age }} ปี)</p>
              <p *ngIf="!date">-</p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6 text-right">
              <p>เบอร์โทรศัพท์ :</p>
            </div>
            <div class="col-6 text-left">
              <p>{{ adminProfile.PHONENUMBER | phoneNO }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isEdit" class="row justify-content-center">
      <div class="col-lg-6 col-md-12">
        <div class="frame">
          <form *ngIf="isEdit" [formGroup]="adminProfileForm">
            <div class="form-group row justify-content-center">
              <label for="Username" class="col-4 text-right col-form-label">Username<lifedi-require></lifedi-require>
                :</label>
              <div class="col-5">
                <input type="text" class="form-control" id="Username" formControlName="username" autocomplete="off">
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <div class="col-5 text-right">
                <p>Email :</p>
              </div>
              <div class="col-6 text-left">
                <p>{{ adminProfile.EMAIL }}</p>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <div class="col-4 text-right">
                <span>รหัสผ่าน :</span>
              </div>
              <div class="col-5 text-left">
                ****** <a routerLink="/changePassword">เปลี่ยนรหัสผ่าน</a>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="gender" class="col-4 text-right col-form-label">เพศ<lifedi-require></lifedi-require> :</label>
              <div class="col-5">
                <select class="custom-select" id="gender" formControlName="gender">
                  <option value="ชาย">ชาย</option>
                  <option value="หญิง">หญิง</option>
                  <option value="ไม่ระบุ">ไม่ระบุ</option>
                </select>
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="dateOfBirth" class="col-4 text-right col-form-label">วัน/เดือน/ปีเกิด :</label>
              <div class="col-5">
                <input type="text" class="form-control" formControlName="dateOfBirth" placement="top" bsDatepicker
                  [(bsValue)]="adminProfileForm.value.dateOfBirth"
                  value="{{ adminProfileForm.value.dateOfBirth | date:'DD/MM/YYYY' }}"
                  [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
              </div>
            </div>
            <div class="form-group row justify-content-center">
              <label for="phoneNO" class="col-4 text-right col-form-label">เบอร์โทรศัพท์ :</label>
              <div class="col-5">
                <input type="text" class="form-control" formControlName="phoneNO" placement="top" MaxLength="10"
                  (keypress)="checkNumber($event)">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <!-- <div class="col-12">
        <div class="frame">
          <h2 class="text-center col-12">ประวัติและความสนใจ</h2>
          <div *ngIf="!isEdit" class="col-10 offset-1">
            <p [innerHtml]="adminProfile.PERSONAL_DESCRIPTION | sanitizeHtml"></p>
          </div>
          <div *ngIf="!isEdit" class="col-1"></div>
          <div *ngIf="isEdit" class="col-12">
            <form [formGroup]="adminProfileForm">
              <angular-editor formControlName="description" placeholder="ใส่ประวัติ และ ความสนใจของคุณ"
                [config]="editorConfig" [(ngModel)]="adminProfile.PERSONAL_DESCRIPTION">
              </angular-editor>
            </form>
          </div>
        </div>
      </div>
    </div> -->
      <lifedi-btn lable="บันทึก" *ngIf="getEdit() && !adminProfileForm.valid"
        customStyle="margin-right: 10px; padding: 0 50px" disabled="true">
      </lifedi-btn>
      <lifedi-btn lable="บันทึก" *ngIf="getEdit() && adminProfileForm.valid"
        customStyle="color:white; background-color: #3E8C1A; margin-right: 10px; padding: 0 50px"
        (click)="clickUpdate(adminProfileForm)">
      </lifedi-btn>
      <lifedi-btn *ngIf="getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(adminProfile)">
      </lifedi-btn>
      <lifedi-btn *ngIf="!getEdit()" [lable]="btnText" [customStyle]="btnCustom" (click)="toggleEdit(adminProfile)">
      </lifedi-btn>
    </div>
  </div>

  <!-- end profile admin -->
